
import { AppInjector } from '../../demo/demo.module';
import { DemoModeMockDataService } from '../../demo/demo-mode-mock-data.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TurfProApiService } from './turf-pro-api.service';
import { TurfProRobot } from './models/turf-pro-robot.type';

@Injectable({
    providedIn: 'root'
})
export class TurfProManagerService {

    private demoModeMockDataService: DemoModeMockDataService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(private turfProApiService: TurfProApiService) {
        if (environment.isDemoMode) {
            this.demoModeMockDataService = AppInjector.get(DemoModeMockDataService);
        }
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    getRobots(): Observable<TurfProRobot[]> {
        if (environment.isDemoMode) { return this.demoModeMockDataService.turfProRobots; }

        return this.turfProApiService.getRobots();
    }
}
